import { BaseIntegrationResult, BaseIntegration, GenericService, BaseServices, IntegrationServiceCount } from '../types/base';

export function serializeIntegration<T>(integration: BaseIntegration<T>): BaseIntegrationResult<T> {
  return {
    services: integration.services,
    count: integration.count(),
  };
}

export function countIntegrationServices<T>(services: GenericService<T>): IntegrationServiceCount {
  const counter = { mobile: 0, desktop: 0, more: 0 };
  const keys = ['mobile', 'desktop', 'more'];

  const countServices = (counter, key) => Object.keys(services[key])
    .reduce((c, service) => {
      c[key] += services[key][service] ? 1 : 0;

      return c;
    }, counter)

  return keys.reduce(countServices, counter);
}
